module.exports = __webpack_public_path__ + "img/pricing_mortgage_black@2x.e23970e8.png";